import React, { Component } from 'react';
import './PlaceHolderMessage.scss';

class PlaceHolderMessage extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        return (
            <div className='place-holder-message'>

                <div className='row'>
                  <div className='col-sm-3 hidden text-center'>

                    <img src="/assets/clipboard.svg" width='100' alt=""/>
                  </div>
                  <div className='col-sm-12'>
                    <h2><strong>Built</strong> for <strong>Every Business</strong></h2>
                    <p>We personally tailor ProQuotes to your exact business needs. Feel free to look around, but for us to make it work for you give us a call for your free consultation.</p>

                    <p>Paul Gillham - <a href="tel:075062058484">07506 2058 484</a> <br/><a className='email' href="mailto:paul@proquotes.co.uk">paul@proquotes.co.uk</a></p>
                  </div>

                </div>



            </div>
        )
    }
}

//<img src="/assets/clipboard.svg" width='100' alt=""/>

export default PlaceHolderMessage;



// WEBPACK FOOTER //
// ./src/views/components/PlaceHolderMessage/index.js